import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { validate as validateToken } from './api/SurveyApi';
import Loading from './Loading';
import Error from './Error';

const ValidateSecaToken = ({ children }) => {
  const { token } = useParams();
  const [validationResult, setValidationResult] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    validateToken(token)
      .then(() => setValidationResult('valid'))
      .catch((e) => {
        setError(e);
        setValidationResult('error');
      });
  }, [token]);
  switch (validationResult) {
    case 'valid':
      return children;
    case 'error':
      return <Error surveyId={token} error={error} />;
    default:
      return <Loading />;
  }
};

export default ValidateSecaToken;
